var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 12.0001L10.79 14.4201L15.62 9.58008",
    stroke: "#BFFF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.44982C11.44 1.85982 12.57 1.85982 13.27 2.44982L14.85 3.80982C15.15 4.06982 15.71 4.27982 16.11 4.27982H17.81C18.87 4.27982 19.74 5.14982 19.74 6.20982V7.90982C19.74 8.29982 19.95 8.86982 20.21 9.16982L21.57 10.7498C22.16 11.4398 22.16 12.5698 21.57 13.2698L20.21 14.8498C19.95 15.1498 19.74 15.7098 19.74 16.1098V17.8098C19.74 18.8698 18.87 19.7398 17.81 19.7398H16.11C15.72 19.7398 15.15 19.9498 14.85 20.2098L13.27 21.5698C12.58 22.1598 11.45 22.1598 10.75 21.5698L9.17 20.2098C8.87 19.9498 8.31 19.7398 7.91 19.7398H6.18C5.12 19.7398 4.25 18.8698 4.25 17.8098V16.0998C4.25 15.7098 4.04 15.1498 3.79 14.8498L2.44 13.2598C1.86 12.5698 1.86 11.4498 2.44 10.7598L3.79 9.16982C4.04 8.86982 4.25 8.30982 4.25 7.91982V6.19982C4.25 5.13982 5.12 4.26982 6.18 4.26982H7.91C8.3 4.26982 8.87 4.05982 9.17 3.79982L10.75 2.44982Z",
    stroke: "#BFFF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree3);
export default __webpack_public_path__ + "static/media/three3.e282d46dd4354b042ab5e9ff5bacdd77.svg";
export { ForwardRef as ReactComponent };